import React, { memo, useEffect, useRef, useState } from 'react';
import { useIntl } from 'react-intl';
import ReactModal from 'react-modal';
import { LoadingIndicator } from '../../aem-core-components';
import { useCartState } from '../../contexts/cart';
import { useUserContext } from '../../aem-core-components/context/UserContext';
import { useDstState } from '../../contexts/dst/dstContext';
import {
    SET_ALL_PCS,
    SET_ALL_TRAINERS,
    SET_NUMBER_OF_FILTERS,
    SET_SEARCHED_PC_LIST,
    SET_SEARCHED_TRAINER_LIST,
    SET_SEARCHED_TRAINER_LIST_BEFORE_FILTERS,
    SET_TRAINER_LIST,
    SET_TRAINER_LIST_BEFORE_FILTERS
} from '../../contexts/dst/constants';
import useMedia from '../../hooks/useMedia';
import useDst from './hooks/useDst';
import useLLP from '../location/hooks/useLLP';
import { useCheckUser } from '../../hooks/useCheckUser';
import { isValidString } from '../global/utils/logger';
import { useFilterState } from '../cap';
import { convertPhoneNumberAsPerSbmChannel, isAuthorMode, isWebView } from '../global/utils/commonUtils';
import { getAddressBylatLong } from '../global/modules/location-autocomplete/api/getLocations';
import { logError } from '../global/utils/logger';
import { getDirectionCTA } from '../checkoutv2/utils/editModuleFunctions';
import { getDSTTrainers } from './api/getDstTrainerAPIs';
import { getStoreDetailsFromPC, getStoreLocations } from '../location/API/getStoreLocations';
import { formatCreditAddress, setLocationInStorage } from '../location/storesLocationFunctions';
import TrainerMap from './trainerMap/TrainerMap';
import LocationLegend from '../global/modules/locationLegend/LocationLegend'
import { LazyDstFilter } from './lazyLoad/LazyLoadDstImports';
import LazyLoadComponent from '../global/lazyLoad/LazyLoadComponent';
import DstTrainerCard from './DstTrainerCard';
import DstLocationSearch from './DstLocationSearch';
import Button from '../global/atoms/button/button';
import Close from '../../resources/images/close.svg';
import ExternalLink from '../../resources/images/external-link.svg';
import Plus from '../../resources/images/plus.svg';
import MapMarker from '../../resources/images/mapmarker.svg';
import MapSpecialtyMarker from '../../resources/images/mapspecialtymarker.svg';
import './dstTrainer.scss';
import { DENIED, GEOLOCATION } from '../global/atoms/GetGeoLocation/constants';
import { SCROLL_TO_TOP, TIER_2_RADIUS } from '../location/constants';
import { DEFAULT_LAT_DST, DEFAULT_LONG_DST } from './constants';
import { STORAGE_CONFIG } from '../../constants/storageConfig';
import { MEDIA_TYPE } from '../global/constants';
import { USER_TYPE } from '../../constants/userDetailsConstants';
import { ENV_CONFIG } from '../../constants/envConfig';


const DstTrainer = () => {
    const [{ isLoading, cashProfileLatLongUpdated, isCreditNewAddress }, cartDispatch] = useCartState();
    const [{ viewCart, projectDetails, startDate }, filterDispatch] = useFilterState();
    const [
        {
            allPCs,
            allTrainers,
            trainerList,
            searchedPcList,
            trainerListBeforeFilters,
            searchedTrainerListBeforeFilters,
            searchedTrainerList
        },
        dispatch
    ] = useDstState();
    const { latSelection, longSelection } = useLLP();
    const isAuthorPage = isAuthorMode();
    const [userState, { getProjectsFromCookie }] = useUserContext();
    const { isUserProfileLoading } = userState;
    const [focusedLocation, setFocusedLocation] = useState({
        lat: DEFAULT_LAT_DST,
        long: DEFAULT_LONG_DST
    });
    const [isNoTrainerAvailable, setIsNoTrainerAvailable] = useState(false);
    const [isSticky, setIsSticky] = useState(false);
    const [locationDeniedError, setLocationDeniedError] = useState(false);
    const [zoomOutMax, setZoomOutMax] = useState(true);
    const [visibleTrainerList, setVisibleTrainerList] = useState([]);
    const [selectedStoreValue, setSelectedStoreValue] = useState();
    const [openFilter, setOpenFilter] = useState(false);
    const [filterData, setFilterData] = useState({});
    const [refs, setRefs] = useState(React.createRef());
    const [isTrainerModalOpen, setIsTrainerModalOpen] = useState(false);
    const [trainerModalData, setTrainerModalData] = useState({});
    const [userLatLong, setuserLatLong] = useState('');
    const [userAddress, setUserAddress] = useState('');
    const [currentAddress, setCurrentAddress] = useState('');
    const [currentCountry, setCurrentCountry] = useState('');
    const [hiddenTrainers, setHiddenTrainers] = useState([]);
    const [isCurrentLocationAllowed, setIsCurrentLocationAllowed] = useState(false);
    const [currentLocation, setCurrentLocation] = useState({});
    const [isUserLocationUsed, setIsUserLocationUsed] = useState(false);
    const userTypeCookie = useCheckUser();
    const intl = useIntl();
    const mediaType = useMedia();
    const { getTrainerSpecialtyObj, getDistance, getDistanceText } = useDst();
    const projectInfoCookies = getProjectsFromCookie();
    const dstTrainerConfigs = ENV_CONFIG?.DST_TRAINER_CONFIGS;
    const subFilterTitle = ENV_CONFIG.DST_FILTER_LABEL;

    const legendItems = [
        {
            icon: <MapSpecialtyMarker tabIndex={-1} aria-hidden={true} />,
            name: dstTrainerConfigs?.specialtrainertitle || "Specialty Trainers",
            content: dstTrainerConfigs?.specialtrainerdescription,
            link: dstTrainerConfigs?.specialtrainingurl
        },
        {
            icon: <MapMarker tabIndex={-1} aria-hidden={true} />,
            name: dstTrainerConfigs?.generaltrainertitle || "Generalist Trainers",
            content: dstTrainerConfigs?.generaltrainerdescription,
            link:  dstTrainerConfigs?.generaltrainingurl
        }
    ];

    useEffect(() => {
        getAllTrainers();
        getAllStores();
    }, []);

    useEffect(() => {
        if (!isUserProfileLoading && isLocationAlreadySearched()) {
            return;
        }
        setIsNoTrainerAvailable(false);
        if (!isUserProfileLoading && userTypeCookie === USER_TYPE.GUEST) {
            zoomOutAndFocus();
            setIsUserLocationUsed(false);
        }
        if (!isUserProfileLoading && userTypeCookie !== USER_TYPE.GUEST) {
            let lat = latSelection();
            let long = longSelection();

            if (lat && long && lat !== '0' && long !== '0') {
                cartDispatch({ type: 'beginLoading' });
                getAddressfromlatlong(lat, long, false, true);
                setIsUserLocationUsed(true);
                setuserLatLong({ lat, long });
            }
        }
    }, [isUserProfileLoading, cashProfileLatLongUpdated, projectInfoCookies?.SLLat]);

    useEffect(() => {
        if (visibleTrainerList?.length > 0) {
            const cardRefs = visibleTrainerList?.reduce((acc, value) => {
                acc[value?.pc] = React.createRef();
                return acc;
            }, {});
            setRefs(cardRefs);
        }
    }, [visibleTrainerList]);

    useEffect(() => {
        if (visibleTrainerList?.length > 0 && selectedStoreValue) {
            document.querySelector('.dst__card-selected')?.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            });
        }
    }, [selectedStoreValue]);

    useEffect(() => {
        setFilterData(initFilterData());
        dispatch({
            type: SET_NUMBER_OF_FILTERS,
            numberOfFilters: 0
        });
    }, [trainerListBeforeFilters, searchedTrainerListBeforeFilters]);

    useEffect(() => {
        if (allTrainers?.length > 0 && allPCs?.length>0) {
            updateTrainerData(allPCs, false);
        }
    }, [allPCs?.length, allTrainers?.length]);

    useEffect(() => {
        if (allTrainers?.length > 0 && searchedPcList?.length && trainerListBeforeFilters?.length) {
            updateTrainerData(searchedPcList, true);
        }
    }, [searchedPcList, allTrainers, trainerListBeforeFilters]);

    useEffect(() => {
        if (userAddress || isCurrentLocationAllowed) {
            if (searchedPcList?.length > 0 && trainerList?.length > 0) {
                updateCardList();
            }
        }
    }, [searchedTrainerList, trainerList]);

    useEffect(() => {
        if (trainerList?.length > 0 && !userAddress) {
            filterVisibleCards();
        }
    }, [trainerList]);

    useEffect(() => {
        dstFilterBodyref.current?.addEventListener('scroll', handleIsSticky);

        return () => {
            dstFilterBodyref.current?.removeEventListener('scroll', handleIsSticky);
        };
    }, [openFilter]);
    const setOpenFilterHandle = () => {
        setOpenFilter(prev => !prev);
    };
    const initFilterData = () => {
        const filter = {};
        filter[subFilterTitle] = {
            selectedOptions: []
        };
        return filter;
    };
    const dstFilterBodyref = useRef(null);

    const handleIsSticky = e => {
        const scrollTop = dstFilterBodyref.current?.scrollTop;
        scrollTop >= SCROLL_TO_TOP ? setIsSticky(true) : setIsSticky(false);
    };

    const updateCardList = () => {
        try {
            if (searchedTrainerList?.length > 0) {
                let list = [...searchedTrainerList];
                let visibleList = list?.length < 10 ? list?.splice(0, list?.length) : list?.splice(0, 10);
                setVisibleTrainerList(visibleList);
                setSelectedStoreValue(visibleList[0]?.pc);
                setHiddenTrainers(list?.length > 0 ? list : []);
            }
        } catch (error) {
            logError(error, false, 'updateCardList');
        }
    };

    const filterVisibleCards = () => {
        try {
            let visibleList = [...visibleTrainerList];
            let updatedVisibleList = [];
            if (visibleList?.length > 0 && trainerList?.length > 0) {
                visibleList?.map(trainer => {
                    const trainerData = trainerList?.find(item => {
                        return item?.firstName == trainer?.firstName && item?.lastName == trainer?.lastName;
                    });
                    if (trainerData) {
                        updatedVisibleList.push(trainer);
                    }
                });
                setVisibleTrainerList(updatedVisibleList);
                setSelectedStoreValue(updatedVisibleList[0]?.pc);
            }
        } catch (error) {
            logError(error, false, 'filterVisibleCards');
        }
    };
    const updateTrainerData = (pcList, isSearchedPcs) => {
        try {
            let updatedList = [];
            if (pcList?.length > 0 && allTrainers?.length > 0) {
                allTrainers?.map(trainer => {
                    const pcDetails = pcList?.find(item => {
                        return item?.pc == trainer?.assignedPc;
                    });
                    if (pcDetails) {
                        const trainerData = isSearchedPcs
                            ? {
                                  ...trainer,
                                  latitude: pcDetails?.latitude,
                                  longitude: pcDetails?.longitude,
                                  companyId: pcDetails?.companyId,
                                  street: pcDetails?.street,
                                  city: pcDetails?.city,
                                  zip: pcDetails?.zip,
                                  distance: pcDetails?.distance,
                                  pc: pcDetails?.pc,
                                  state: pcDetails?.state
                              }
                            : {
                                  ...trainer,
                                  latitude: pcDetails?.latitude,
                                  longitude: pcDetails?.longitude,
                                  companyId: pcDetails?.companyId
                              };
                        updatedList.push(trainerData);
                    }
                });
                updatedList.sort((a, b) => {
                    return a?.distance - b?.distance;
                });
                if (isSearchedPcs) {
                    dispatch({
                        type: SET_SEARCHED_TRAINER_LIST_BEFORE_FILTERS,
                        searchedTrainerListBeforeFilters: updatedList
                    });
                    dispatch({
                        type: SET_SEARCHED_TRAINER_LIST,
                        searchedTrainerList: updatedList
                    });
                    if (updatedList?.length == 0) {
                        setVisibleTrainerList([]);
                        setIsNoTrainerAvailable(true);
                        zoomOutAndFocus();
                        return;
                    }
                    dispatch({
                        type: SET_TRAINER_LIST,
                        trainerList: trainerListBeforeFilters
                    });
                } else {
                    dispatch({
                        type: SET_TRAINER_LIST,
                        trainerList: updatedList
                    });
                    dispatch({
                        type: SET_TRAINER_LIST_BEFORE_FILTERS,
                        trainerListBeforeFilters: updatedList
                    });
                }
                setFilterData(initFilterData());
                dispatch({
                    type: SET_NUMBER_OF_FILTERS,
                    numberOfFilters: 0
                });
            }
        } catch (error) {
            logError(error, false, 'updateTrainerData');
        }
    };
    const getAllTrainers = async () => {
        cartDispatch({ type: 'beginLoading' });
        const { data } = await getDSTTrainers();
        if (data?.data?.dstTrainerMapList?.items?.length > 0) {
            dispatch({
                type: SET_ALL_TRAINERS,
                allTrainers: data?.data?.dstTrainerMapList?.items
            });
        }
    };

    const isLocationAlreadySearched = () => {
        const locationSearchFields = localStorage.getItem(STORAGE_CONFIG.LOCAL_STORAGE.LOCATIONSEARCHFIELDS)
            ? JSON.parse(localStorage.getItem(STORAGE_CONFIG.LOCAL_STORAGE.LOCATIONSEARCHFIELDS))
            : {};
        const { lat, long, formattedAddress } = locationSearchFields;
        if (lat && long && formattedAddress) {
            setIsUserLocationUsed(true);
            setIsNoTrainerAvailable(false);
            getStores(lat, long);
            setuserLatLong({ lat, long });
            setUserAddress(formattedAddress);
            return true;
        }
        return false;
    };

    const getAllStores = async () => {
        cartDispatch({ type: 'beginLoading' });
        const { data } = await getStoreLocations();
        if (data?.data?.pcList?.length > 0) {
            dispatch({
                type: SET_ALL_PCS,
                allPCs: data?.data?.pcList
            });
        }
        cartDispatch({ type: 'endLoading' });
    };

    const isBodyVisible = () => {
        if (visibleTrainerList?.length > 0) {
            return true;
        } else if (visibleTrainerList?.length === 0 && isNoTrainerAvailable) {
            return true;
        }
        return false;
    };

    const getStoreDetailsWithPC = async (pc, companyId) => {
        const storeData = await getStoreDetailsFromPC(pc, companyId);
        return storeData?.data?.data?.pcList[0];
    };
    const inVisibleList = trainer => {
        const isInList = visibleTrainerList.find(
            element => element?.firstName == trainer.firstName && element?.lastName == trainer?.lastName
        );
        return isInList ? true : false;
    };

    const checkIfStoreVisible = async (pcId, companyId) => {
        const trainersInVisibleList = visibleTrainerList?.filter(i => i?.pc == pcId);
        let selectedItemIndex = -1;
        let selectedItem = [];
        if (trainersInVisibleList?.length === 0) {
            for (let index in hiddenTrainers) {
                if (hiddenTrainers[index]?.pc == pcId) {
                    selectedItemIndex = index;
                    selectedItem.push(hiddenTrainers[index]);
                }
            }
            if (trainerList?.length > 0) {
                if (selectedItem?.length == 0) {
                    cartDispatch({ type: 'beginLoading' });
                    const selectedStoreDetails = await getStoreDetailsWithPC(pcId, companyId || 1);
                    if (userLatLong?.lat || isCurrentLocationAllowed) {
                        selectedStoreDetails['distance'] = await getDistance(
                            selectedStoreDetails?.latitude,
                            selectedStoreDetails?.longitude,
                            isCurrentLocationAllowed,
                            currentLocation,
                            userLatLong
                        );
                    }
                    cartDispatch({ type: 'endLoading' });
                    trainerList?.map(trainer => {
                        if (selectedStoreDetails?.pc == trainer?.assignedPc && !inVisibleList(trainer)) {
                            const trainerData = { ...trainer, ...selectedStoreDetails };
                            trainerData['email'] = trainer?.email;
                            trainerData['phoneNumber'] = trainer?.phoneNumber;
                            selectedItem.push(trainerData);
                        }
                    });
                }
            }
            const trainerArray = [...selectedItem, ...visibleTrainerList];
            setVisibleTrainerList(trainerArray);
            const list = hiddenTrainers;
            list?.splice(selectedItemIndex, 1);
            setHiddenTrainers(list);
        }
        setSelectedStoreValue(pcId);
    };
    const getStores = async (latitude, longitude, distance = parseInt(ENV_CONFIG.LLP_INITIAL_RADIUS)) => {
        cartDispatch({ type: 'beginxLoading' });
        const { data } = await getStoreLocations(latitude, longitude, distance);
        if (data?.data?.pcList?.length > 0) {
            setIsNoTrainerAvailable(false);
            dispatch({
                type: SET_SEARCHED_PC_LIST,
                searchedPcList: data?.data?.pcList
            });
            setFocusedLocation({ lat: Number(latitude), long: Number(longitude) });
            setZoomOutMax(false);
        } else {
            if (distance >= TIER_2_RADIUS) {
                cartDispatch({ type: 'endLoading' });
                setFocusedLocation({
                    lat: Number(data?.data?.pcList[0].latitude),
                    long: Number(data?.data?.pcList[0].longitude)
                });
                setZoomOutMax(false);
                return;
            }
            distance = distance + 100;
            getStores(latitude, longitude, distance);
        }
        cartDispatch({ type: 'endLoading' });
    };

    const handleViewMoreClick = item => {
        setIsTrainerModalOpen(!isTrainerModalOpen);
        setTrainerModalData(item);
    };
    const phoneNo = trainerModalData?.phoneNumber;
    const hrefphone = `tel:${phoneNo}`;
    const hrefEmail = `mailto:${trainerModalData?.email}`;

    const onClickGetDirections = () => {
        getDirectionCTA(trainerModalData, {}, viewCart, userTypeCookie, projectDetails, true, '');
    };
    const handleTrainerClose = () => {
        setIsTrainerModalOpen(!isTrainerModalOpen);
    };

    const getAddressfromlatlong = async (lat, long, isCurrentAddress, isUserLocation = false) => {
        cartDispatch({ type: 'beginLoading' });
        const data = await getAddressBylatLong(lat, long);
        const currentCountry = data?.data?.results[0]?.addressComponents.filter(
            address => address?.types[0] === 'country'
        );
        if (isUserLocation) {
            if (userTypeCookie === USER_TYPE.CREDIT) {
                setUserAddress(
                    formatCreditAddress(userTypeCookie, viewCart, isCreditNewAddress, getProjectsFromCookie)
                );
                setLocationInStorage({
                    lat,
                    long,
                    formattedAddress: formatCreditAddress(
                        userTypeCookie,
                        viewCart,
                        isCreditNewAddress,
                        getProjectsFromCookie
                    )
                });
            } else {
                setLocationInStorage({
                    lat,
                    long,
                    formattedAddress: viewCart?.location || data?.data?.results[0]?.formattedAddress
                });
                setUserAddress(viewCart?.location || data?.data?.results[0]?.formattedAddress);
            }
        } else if (currentCountry[0]?.shortName === 'US' || currentCountry[0]?.shortName === 'CA') {
            setLocationInStorage({ lat, long, formattedAddress: data?.data?.results[0]?.formattedAddress });
            if (isCurrentAddress) {
                localStorage.setItem('companyID', currentCountry[0]?.shortName === 'CA' ? '2' : '1');
                setCurrentAddress(data?.data?.results[0]?.formattedAddress);
                setCurrentCountry(currentCountry[0]?.shortName.toLowerCase());
                setIsUserLocationUsed(false);
            } else {
                setIsUserLocationUsed(false);
                setUserAddress(data?.data?.results[0]?.formattedAddress);
            }
        } else {
            setCurrentAddress('');
            setCurrentCountry('us');
            setIsNoTrainerAvailable(true);
            zoomOutAndFocus();
            setuserLatLong('');
            setUserAddress('');
            setCurrentAddress('');
        }
        getStores(lat, long);
    };

    const onClearingAddress = async () => {
        setVisibleTrainerList([]);
        dispatch({
            type: SET_TRAINER_LIST,
            trainerList: trainerListBeforeFilters
        });
        setUserAddress('');
        setCurrentAddress('');
        setFilterData(initFilterData());
        dispatch({
            type: SET_NUMBER_OF_FILTERS,
            numberOfFilters: 0
        });
        setuserLatLong('');
        setIsNoTrainerAvailable(false);
        zoomOutAndFocus();
        setIsUserLocationUsed(false);
        setHiddenTrainers([]);
        setSelectedStoreValue('');
        setLocationInStorage({
            DEFAULT_LAT_DST,
            DEFAULT_LONG_DST,
            formattedAddress: ''
        });
    };

    const getCurrentLocation = () => {
        if (navigator.geolocation && !isWebView) {
            navigator?.permissions?.query({ name: GEOLOCATION })?.then(function (result) {
                if (result?.state == DENIED) {
                    setLocationDeniedError(true);
                }
            });
            navigator?.geolocation?.getCurrentPosition(position => {
                const lat = position.coords.latitude;
                const long = position.coords.longitude;
                // to mock current location
                // const lat = 38.9066019;
                // const long = -77.04828599999999;
                setLocationDeniedError(false);
                setCurrentLocation({ lat: lat, long: long });
                setFocusedLocation({ lat: lat, long: long });
                getAddressfromlatlong(lat, long, true, false);
                setIsCurrentLocationAllowed(true);
            });
        } else {
            setIsCurrentLocationAllowed(false);
            setCurrentCountry('us');
        }
    };

    const handleShowMore = () => {
        const list = hiddenTrainers;
        let addedStores = list.splice(0, 10);
        let visibleList = [...visibleTrainerList, ...addedStores];
        setVisibleTrainerList(visibleList);
        setHiddenTrainers(list);
    };

    const renderNeedHelpContact = () => {
        const hrefphone = `tel:${ENV_CONFIG.DST_NEED_HELP_CONTACT}`;
        return (
            <div className="dst__need-help-contact">
                <small>{ENV_CONFIG.DST_CALL_US_MESSAGE}</small>{' '}
                <a className="dst__need-help-number" href={hrefphone}>
                    {ENV_CONFIG.DST_NEED_HELP_CONTACT}
                </a>
            </div>
        );
    };

    const getTrainerSpecialty = qualifiedTrainingSet => {
        const specialityObj = getTrainerSpecialtyObj();
        const qualifiedTrainingLeftList = [];
        const qualifiedTrainingRightList = [];
        qualifiedTrainingSet?.forEach((element, index) => {
            const qualifiedTrainingItem = (
                <li key={specialityObj[element]} className="trainermodal__item" tabIndex={'0'}>
                    {specialityObj[element]}
                </li>
            );
            if (index % 2 === 0) {
                qualifiedTrainingLeftList?.push(qualifiedTrainingItem);
            } else {
                qualifiedTrainingRightList?.push(qualifiedTrainingItem);
            }
        });
        return (
            <>
                <ul className="trainermodal__list">{qualifiedTrainingLeftList}</ul>
                <ul className="trainermodal__list">{qualifiedTrainingRightList}</ul>
            </>
        );
    };

    const zoomOutAndFocus = () => {
        setZoomOutMax(true);
        setFocusedLocation({ lat: DEFAULT_LAT_DST, long: DEFAULT_LONG_DST });
    };

    const renderMap = () => {
        return (
            <TrainerMap
                selectedLatLong={focusedLocation}
                defaultCenter={{
                    lat: focusedLocation.lat,
                    long: focusedLocation.long
                }}
                onClickMarker={(item, companyId) => {
                    setZoomOutMax(false);
                    checkIfStoreVisible(item, companyId);
                }}
                selectedStoreValue={selectedStoreValue}
                storesList={trainerList}
                isCurrentLocationAllowed={isCurrentLocationAllowed}
                currentLocation={currentLocation}
                setFocusedLocation={setFocusedLocation}
                zoomOutMax={zoomOutMax}
                userLatLong={userLatLong}
                legendItems={legendItems}
            />
        );
    };

    const renderFilter = (wrapClass, filterTitleClass, filterBodyRef) => {
        return (
            <LazyLoadComponent fallback={<></>}>
                <LazyDstFilter
                    filterBodyRef={filterBodyRef}
                    wrapClass={wrapClass}
                    filterTitleClass={filterTitleClass}
                    isFilterModalOpen={openFilter}
                    setIsFilterModalOpen={setOpenFilter}
                    filterData={filterData}
                    setFilterData={setFilterData}
                    subfiltertitle={subFilterTitle}
                    initFilterData={initFilterData}
                    userAddress={userAddress}
                />
            </LazyLoadComponent>
        );
    };

    const renderDstTrainerCard = item => {
        return (
            <React.Fragment key={`${item?.firstName} ${item?.lastName}`}>
                    <DstTrainerCard
                        handleViewMoreClick={() => handleViewMoreClick(item)}
                        item={item}
                        setSelectedStoreValue={setSelectedStoreValue}
                        selectedStoreValue={selectedStoreValue}
                        startDate={startDate}
                        cardRef={refs[item?.pc]}
                        setFocusedLocation={setFocusedLocation}
                        setZoomOutMax={setZoomOutMax}
                        userAddress={userAddress}
                    />
            </React.Fragment>
        );
    };

    const renderNoTrainerCard = () => {
        const phoneNumber = convertPhoneNumberAsPerSbmChannel(ENV_CONFIG.DST_NO_STORE_CONTACT);
        const hrefphone = `tel:${phoneNumber}`;
        const noTrainerBody = isValidString(ENV_CONFIG.DST_NO_TRAINERS_BODY_2)
            ? `${ENV_CONFIG.DST_NO_TRAINERS_BODY_2}`?.split('#nonearbyphonenumber')
            : [];
        if (visibleTrainerList?.length === 0 && isNoTrainerAvailable) {
            return (
                <div className="noTrainerAvailableCard">
                    <h6 className="noTrainerTitle">{ENV_CONFIG.DST_NO_TRAINERS_TITLE}</h6>
                    <small className="noTrainerBody">
                        {ENV_CONFIG.DST_NO_TRAINERS_BODY_1}{' '}
                        <span className="noTrainerPhoneText">
                            {noTrainerBody?.length > 0 ? noTrainerBody[0] : ''}{' '}
                            <a className="noTrainerPhoneNumber" href={hrefphone}>
                                {phoneNumber}
                            </a>{' '}
                            {noTrainerBody?.length > 1 ? noTrainerBody[1] : ''}
                        </span>
                    </small>
                </div>
            );
        }
    };

    const getNeedHelpContact = isDesktop => {
        if (isDesktop) {
            return renderNeedHelpContact;
        } else {
            return () => {};
        }
    };

    const renderLocationSearch = isDesktop => {
        return (
            <DstLocationSearch
                wrapClass={isDesktop ? 'dst__aside-top--desktop' : 'dst__aside-top--tablet'}
                getCurrentLocation={getCurrentLocation}
                getStores={getStores}
                isCurrentLocationAllowed={isCurrentLocationAllowed}
                currentAddress={currentAddress}
                currentCountry={currentCountry}
                setOpenFilterHandle={setOpenFilterHandle}
                setIsUserLocationUsed={setIsUserLocationUsed}
                isUserLocationUsed={isUserLocationUsed}
                setIsCurrentLocationAllowed={setIsCurrentLocationAllowed}
                setFocusedLocation={setFocusedLocation}
                setuserLatLong={setuserLatLong}
                userAddress={userAddress}
                setUserAddress={setUserAddress}
                locationDeniedError={locationDeniedError}
                setLocationDeniedError={setLocationDeniedError}
                onClearingAddress={onClearingAddress}
                renderNeedHelpContact={getNeedHelpContact(isDesktop)}
            />
        );
    };

    return (
        <section className={`${isLoading ? 'block__dst loadingState' : 'block__dst'} ${isAuthorPage ? 'block__dst--editor' : 'block__dst--viewMode'}`}>
            {isLoading && (
                <div className={`dstLoader`}>
                    <LoadingIndicator />
                </div>
            )}

            <ReactModal
                isOpen={isTrainerModalOpen}
                className="trainermodal"
                onRequestClose={handleTrainerClose}
                role="none"
                aria={{
                    labelledby: 'trainertitle'
                }}>
                <div className="trainermodal__top">
                    <div className="trainermodal__title-wrap">
                        <h6 className="trainermodal__title" tabIndex={'0'} id="trainertitle">
                            {trainerModalData?.firstName} {trainerModalData?.lastName}
                        </h6>
                        <Button
                            tabIndex={'0'}
                            onClick={handleTrainerClose}
                            buttonAriaLabel={intl.formatMessage({ id: 'dts-trainer-modal-close' })}>
                            <Close tabIndex={'-1'} aria-hidden={true} />
                        </Button>
                    </div>
                    <div className="trainermodal__list-wrap">
                        {getTrainerSpecialty(trainerModalData?.qualifiedTrainingSet)}
                    </div>
                </div>
                <div className="trainermodal__bottom">
                    <div className="trainermodal__bottom-wrap">
                        <address
                            className="trainermodal__address"
                            tabIndex={0}
                            aria-label={intl.formatMessage({ id: 'dts-trainer-address' })}>
                            <span className="dst__card-street">{`${trainerModalData?.street?.toLowerCase()}`}</span>
                            <span>{`${trainerModalData?.city?.toLowerCase()}`}</span>
                            <span>{`${trainerModalData?.state}, ${trainerModalData?.zip}`}</span>
                        </address>
                        {trainerModalData?.distance > 0 && (
                            <small>
                                {Number(trainerModalData?.distance).toFixed()} {getDistanceText()}
                            </small>
                        )}
                    </div>

                    <div className="trainermodal__email">
                        <a
                            className="trainermodal__link"
                            href={hrefEmail}
                            aria-label={intl.formatMessage({ id: 'dts-trainer-email' })}>
                            {trainerModalData?.email?.toLowerCase()}
                        </a>
                    </div>
                    <div className="trainermodal__action">
                        <a
                            href={hrefphone}
                            className="trainermodal__link"
                            title={intl.formatMessage({ id: 'dts-trainer-phone-number' })}>
                            {phoneNo}
                        </a>
                        <Button
                            role="link"
                            onClick={onClickGetDirections}
                            className="trainermodal__externallink"
                            buttonAriaLabel={intl.formatMessage({ id: 'dts-trainer-view-google-map' })}>
                            <ExternalLink tabIndex={'-1'} aria-hidden={true} className="trainermodal__icon" />{' '}
                            {intl.formatMessage({ id: 'dst-card-view-directions' })}
                        </Button>
                    </div>
                </div>
            </ReactModal>

            {mediaType === 'TABLET' || mediaType === 'MOBILE' ? (
                <>
                    {renderLocationSearch(false)}
                    <div className="dst__map-wrap">{renderMap()}</div>
                    {mediaType === MEDIA_TYPE.mobile && <LocationLegend legendItems={legendItems} classNamePrefix="dst"/>}
                    <div>{renderNeedHelpContact()}</div>
                    {isBodyVisible() && (
                        <div className="dst__body">
                            {renderNoTrainerCard()}
                            {visibleTrainerList?.length !== 0 &&
                                visibleTrainerList?.map(item => renderDstTrainerCard(item))}
                            {hiddenTrainers?.length > 0 && (
                                <Button
                                    className="button show-more-btn"
                                    buttonAriaLabel={`${intl.formatMessage({ id: 'location:show-more-cta' })}`}
                                    onClick={handleShowMore}>
                                    {intl.formatMessage({ id: 'location:show-more-cta' })} <Plus />
                                </Button>
                            )}
                        </div>
                    )}
                    {openFilter && renderFilter('location__filter location__filter--mobile', '', '')}
                </>
            ) : (
                <>
                    {renderMap()}
                    <aside
                        className={`dst__aside ${
                            visibleTrainerList.length == 0 && !isNoTrainerAvailable ? 'dst__aside--nodata' : ''
                        }`}>
                        {renderLocationSearch(true)}
                        {isBodyVisible() && (
                            <div className="dst__body">
                                {renderNoTrainerCard()}
                                {visibleTrainerList?.length !== 0 &&
                                    visibleTrainerList?.map(item => renderDstTrainerCard(item))}
                                {hiddenTrainers?.length > 0 && (
                                    <Button className="button show-more-btn" onClick={handleShowMore}>
                                        {intl.formatMessage({ id: 'location:show-more-cta' })} <Plus />
                                    </Button>
                                )}
                            </div>
                        )}
                    </aside>
                    {openFilter &&
                        renderFilter(
                            'dst__filter--desktop',
                            isSticky ? 'dst__filter-top--sticky' : '',
                            dstFilterBodyref
                        )}
                </>
            )}
        </section>
    );
};

export default memo(DstTrainer);
